@import 'styles/mixins';
@import 'styles/variables';

.deactivateButton.deactivateButton {
  color: var(--red-70);
  min-width: fit-content;

  &:hover,
  &:focus,
  &:active {
    color: var(--red-70);
  }
}
